import React, { memo } from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';

import theme from '../../theme';
import AlertComponent from '../AlertComponent/AlertComponent';

import FormPunchSetField from './FormPunchSetField';
import { errorHandler } from './formUtils';

const StyledList = styled(List)(() => ({
  display: 'flex',
  borderRadius: '16px',
}));

const FormPunchPicker = memo(
  ({ additiveElements, fieldErrorData, initialValue, input, label, listViewGridSpacing, meta }) => {
    const { onChange } = input;
    const setRFFValue = onChange;
    const punchData = get('value', input);
    const errorMessage = errorHandler(input, meta, fieldErrorData);
    const handlePunchChange = (newPunchData) => {
      const { in: inData, out: outData } = newPunchData.at(0);

      setRFFValue(
        !inData?.stamp && !outData?.stamp
          ? []
          : [
              {
                in: { stamp: inData?.stamp },
                out: { stamp: outData?.stamp },
              },
            ]
      );
    };

    return (
      <Grid container spacing={listViewGridSpacing}>
        <Grid item xs>
          <StyledList name={input.name} label={label} values={input.values || initialValue}>
            <Box sx={{ width: '100%' }}>
              <Box>
                <ListItem sx={{ display: 'flex', padding: theme.spacing(1, 0) }}>
                  <FormPunchSetField
                    punchData={punchData.length > 0 ? punchData.at(0) : punchData}
                    handlePunchChange={handlePunchChange}
                  />
                </ListItem>
              </Box>
              <Grid item xs={12} sx={{ marginBottom: '10px' }}>
                <AlertComponent isOpen={!!errorMessage} severity="error" message={errorMessage} />
              </Grid>
            </Box>
          </StyledList>
        </Grid>
        {additiveElements}
      </Grid>
    );
  }
);
FormPunchPicker.propTypes = {
  additiveElements: PropTypes.element,
  fieldErrorData: PropTypes.string,
  initialValue: PropTypes.number,
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    values: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  label: PropTypes.string,
  listViewGridSpacing: PropTypes.number,
  meta: PropTypes.shape(),
};

export default FormPunchPicker;
